import { useLanguage } from "../context/LanguageContext";

const MarqueeRow = ({ items, isRtl, hidden }) => (
  <div className="flex w-max shrink-0 items-center" aria-hidden={hidden || undefined}>
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`font-head whitespace-nowrap px-8 text-2xl text-ink/70 md:text-3xl ${
            isRtl ? "" : "italic"
          }`}
        >
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-bronze/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { t, isRtl } = useLanguage();
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-line bg-sand py-6"
    >
      <div className="animate-marquee flex w-max">
        <MarqueeRow items={t.marquee} isRtl={isRtl} />
        <MarqueeRow items={t.marquee} isRtl={isRtl} hidden />
      </div>
    </div>
  );
};

export default Marquee;
